var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
export default React.memo(function (props) {
    return (React.createElement("svg", __assign({ width: 48, height: 48, viewBox: "0 0 48 48", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("path", { d: "M33 11a4 4 0 014 4v18a4 4 0 01-4 4H15a4 4 0 01-4-4V15a4 4 0 014-4h18zm-9 5c-1.686 0-3.07 1.323-3.218 3.011h-2.954a.828.828 0 100 1.656l.248-.001v8.264c0 .022.002.043.005.064.049 1.208.559 2.01 1.59 2.01h8.395c1.122 0 1.773-.764 1.85-1.964a.754.754 0 00.007-.11v-8.264h.25a.828.828 0 000-1.654h-2.955C27.07 17.322 25.686 16 24 16zm4.307 4.666v8.132l-.006.116c-.048.393-.345.435-.532.435h-1.077v-8.683h1.615zm-7 0v8.683h-1.191l-.097-.005c-.297-.04-.324-.262-.326-.48l-.001-8.198h1.615zm3.769 0v8.683h-2.153v-8.683h2.153zM24 17.656c.792 0 1.451.584 1.589 1.355h-3.178c.138-.771.797-1.356 1.589-1.356z", fill: "currentColor", stroke: "none", strokeWidth: 1, fillRule: "evenodd" })));
});
